import { c as _c } from "react/compiler-runtime";
import { DndContext, DragEndEvent, DragOverlay, DropAnimation, MeasuringStrategy, MouseSensor, TouchSensor, UniqueIdentifier, closestCenter, defaultDropAnimationSideEffects, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import React, { PropsWithChildren, useState, type JSX } from 'react';
import DragOverlayPortal from './drag-overlay-portal';
const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4'
      }
    }
  })
};
interface SortableProps<T extends {
  id: number | string;
}> extends PropsWithChildren {
  draggable: (element: T) => JSX.Element;
  items: T[];
  onMove: (activeId: number, activeIndex: number, overIndex: number) => Promise<void>;
  disabled?: boolean;
  isPortal?: boolean;
}
const Sortable = t0 => {
  const $ = _c(23);
  const {
    items,
    onMove,
    draggable,
    children,
    disabled,
    isPortal
  } = t0;
  const [activeId, setActiveId] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      activationConstraint: {
        distance: 10
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      activationConstraint: {
        delay: 100,
        tolerance: 5
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sensors = useSensors(useSensor(MouseSensor, t1), useSensor(TouchSensor, t2));
  let t3;
  if ($[2] !== activeId || $[3] !== children || $[4] !== disabled || $[5] !== draggable || $[6] !== isPortal || $[7] !== items || $[8] !== onMove || $[9] !== sensors) {
    let t4;
    if ($[11] !== activeId) {
      t4 = item => item.id === activeId;
      $[11] = activeId;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    const activeElement = items.find(t4);
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = async () => {
        setActiveId(null);
      };
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    const onDragCancel = t5;
    let t6;
    if ($[14] !== items || $[15] !== onMove) {
      t6 = async t7 => {
        const {
          active,
          over
        } = t7;
        if (over && active.id !== over?.id) {
          const activeIndex = items.findIndex(t8 => {
            const {
              id
            } = t8;
            return id === active.id;
          });
          const overIndex = items.findIndex(t9 => {
            const {
              id: id_0
            } = t9;
            return id_0 === over.id;
          });
          if (activeIndex > -1 && overIndex > -1) {
            await onMove(Number(active.id), activeIndex, overIndex);
          }
        }
        setActiveId(null);
      };
      $[14] = items;
      $[15] = onMove;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    const onDragEnd = t6;
    let t7;
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        droppable: {
          strategy: MeasuringStrategy.Always
        }
      };
      t8 = t9 => {
        const {
          active: active_0
        } = t9;
        setActiveId(active_0.id);
      };
      $[17] = t7;
      $[18] = t8;
    } else {
      t7 = $[17];
      t8 = $[18];
    }
    let t9;
    if ($[19] !== children || $[20] !== disabled || $[21] !== items) {
      t9 = <SortableContext items={items} strategy={verticalListSortingStrategy} disabled={disabled}>{children}</SortableContext>;
      $[19] = children;
      $[20] = disabled;
      $[21] = items;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    t3 = <DndContext sensors={sensors} collisionDetection={closestCenter} measuring={t7} onDragStart={t8} onDragEnd={onDragEnd} onDragCancel={onDragCancel}>{t9}{activeId && <>{isPortal ? <DragOverlayPortal dropAnimation={dropAnimationConfig} className="cursor-grabbing opacity-0">{activeElement ? draggable(activeElement) : null}</DragOverlayPortal> : <DragOverlay dropAnimation={dropAnimationConfig} className="cursor-grabbing opacity-0">{activeElement ? draggable(activeElement) : null}</DragOverlay>}</>}</DndContext>;
    $[2] = activeId;
    $[3] = children;
    $[4] = disabled;
    $[5] = draggable;
    $[6] = isPortal;
    $[7] = items;
    $[8] = onMove;
    $[9] = sensors;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default Sortable;